import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { PROGRAMS, IMAGES } from "../data/site";
import { Reveal, Label, INTERESTED_URL } from "../components/ui-kit";

export default function Programs() {
  return (
    <>
      <section className="relative pt-40 pb-20 grain overflow-hidden" data-testid="programs-hero">
        <img src={IMAGES.hyroxBanner} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/70 to-black" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
          <Label>Programs</Label>
          <h1 className="font-display uppercase text-white text-5xl md:text-8xl leading-[0.9] mt-6 max-w-4xl">Something for every body.</h1>
          <p className="mt-8 text-lg md:text-xl text-lightgrey max-w-2xl">Whether you're taking your very first step or chasing a new personal best, there's a program here built for you.</p>
        </div>
      </section>

      <section className="bg-black pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 space-y-6">
          {PROGRAMS.map((p, i) => {
            const external = Boolean(p.url);
            const rowClass = "group grid md:grid-cols-2 gap-0 rounded-3xl overflow-hidden border border-white/10 bg-charcoal hover:border-gold/40 transition-all duration-300";
            const inner = (
              <>
                <div className={`relative h-64 md:h-auto overflow-hidden ${i % 2 ? "md:order-2" : ""}`}>
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-8 md:p-12 flex flex-col justify-center">
                  <span className="text-gold text-sm uppercase tracking-widest">0{i + 1}</span>
                  <h2 className="font-display text-4xl md:text-5xl text-white uppercase mt-2">{p.title}</h2>
                  <p className="text-gold mt-2">{p.tagline}</p>
                  <p className="mt-4 text-lightgrey">{p.blurb}</p>
                  <div className="mt-6 flex items-center gap-3 flex-wrap">
                    <span className="inline-flex items-center rounded-full bg-gold/15 border border-gold/30 text-gold font-bold text-sm px-4 py-1.5" data-testid={`program-price-${p.slug}`}>{p.price}</span>
                    <span className="inline-flex items-center gap-2 text-white font-bold group-hover:text-gold transition">{external ? "Join Now" : "Learn More"} <ArrowRight size={18} /></span>
                  </div>
                </div>
              </>
            );
            return (
              <Reveal key={p.slug} delay={i * 0.05}>
                {external ? (
                  <a href={p.url} target="_blank" rel="noopener noreferrer" data-testid={`program-row-${p.slug}`} className={rowClass}>{inner}</a>
                ) : (
                  <Link to={`/programs/${p.slug}`} data-testid={`program-row-${p.slug}`} className={rowClass}>{inner}</Link>
                )}
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="bg-black pb-28" data-testid="book-a-call">
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <div className="relative rounded-3xl border border-gold/30 bg-gradient-to-br from-gold/10 via-transparent to-transparent p-10 md:p-16 text-center overflow-hidden">
            <div className="absolute -top-16 -right-16 w-56 h-56 bg-gold/15 blur-3xl rounded-full" />
            <div className="relative">
              <Label className="justify-center">Still deciding?</Label>
              <h2 className="font-display uppercase text-white text-4xl md:text-6xl mt-4 leading-none">Not sure we're<br />the right fit?</h2>
              <p className="mt-5 text-lightgrey text-lg max-w-xl mx-auto">No pressure at all. Book a quick, friendly call with us — we'll answer your questions, learn about your goals, and help you figure out if HFC is the place for you.</p>
              <div className="mt-9 flex justify-center">
                <a
                  href={INTERESTED_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="book-call-btn"
                  className="group inline-flex items-center gap-2 rounded-full bg-gold text-black font-bold px-10 py-5 text-lg hover:bg-white transition-colors duration-300"
                >
                  <Phone size={20} /> Book a Call
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
